import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="9" viewBox="0 0 6 9" width="6" className={className}>
    <path d="M1 8L1 1" stroke="black" stroke-width="2" stroke-linecap="round" />
    <path d="M5 8L5 1" stroke="black" stroke-width="2" stroke-linecap="round" />
  </svg>
);

export default Icon;
